// extracted by mini-css-extract-plugin
module.exports = {"AuthorRemark":"AuthorRemark_AuthorRemark__2ufeJ"};